<template>
  <div class="login-container">
    <div class="login-card">
      <h3 class="login-title">Login</h3>
      <!-- Login Form -->
      <b-form @submit.prevent="handleLogin">
        <div class="form-group">
          <b-form-input
            v-model="username"
            required
            placeholder="Username"
            size="lg"
            class="form-control"
          ></b-form-input>
        </div>

        <div class="form-group">
          <b-form-input
            v-model="password"
            required
            type="password"
            placeholder="Password"
            size="lg"
            class="form-control"
          ></b-form-input>
        </div>

        <b-button
          type="submit"
          variant="primary"
          size="lg"
          class="w-100 submit-btn"
        >
          Login
        </b-button>
      </b-form>

      <!-- Error Message -->
      <b-alert v-if="error" variant="danger" dismissible class="mt-3">
        {{ error }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
    };
  },
  methods: {
    ...mapActions(["login"]),
    async handleLogin() {
      try {
        await this.login({ username: this.username, password: this.password });
        this.$router.push("/dashboard");
      } catch (err) {
        this.error = "Invalid username or password.";
      }
    },
  },
};
</script>

<style scoped>
.login-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #343a40;
  text-transform: uppercase;
  text-align: center;
}

/* Centering the Login Form */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
}

/* Card Styles */
.login-card {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Input Styling */
.form-group {
  margin-bottom: 1.5rem;
}

.form-control {
  font-size: 1.1rem;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: border-color 0.3s ease;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Button Styles */
.submit-btn {
  font-size: 1.2rem;
  padding: 0.8rem;
  font-weight: 600;
  background-color: #007bff;
  border-color: #007bff;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background-color: #0056b3;
  border-color: #004085;
}

/* Error Alert Styling */
b-alert {
  font-size: 1rem;
  padding: 1rem;
}

/* Responsive Design */
@media (max-width: 600px) {
  .login-card {
    padding: 1.5rem;
  }
  .submit-btn {
    font-size: 1.1rem;
  }
}
</style>
